@if (breadcrumbs?.length > 0) {
<div class="no-wrap p-t-2 p-b-2">
    @for (crumb of getAllCrumbs('Home'); track crumb; let last = $last) {
    <span>
        <href [ngClass]="last && isSelfLocation(crumb) ? 'col-1 c1' : 'col-11 c1'"
              [link]="crumb?.url">{{crumb.label}}</href>
    </span>
    <!--
        NOTE:
        size here in ems is to keep chevron scale propertionaly to the label
        this requires both span and i having the same typography class
        -->
    @if (!last) {
    <i [style.font-size.em]="0.62"
       class="icon-chevron-right col-11 m-r-2 m-l-2 inline-flex m-t-1"></i>
    }
    }
</div>
}
